import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

interface OverlayHeaderProps {
  title: string;
  closeOverlay: () => void;
}

const OverlayHeader = ({ title, closeOverlay }: OverlayHeaderProps) => {
  return (
    <div
      className="p-2 text-black d-flex align-items-center justify-content-between"
      style={{ borderTopLeftRadius: 7, borderTopRightRadius: 7 }}
    >
      <span className="fw-semibold mx-auto">{title}</span>
      <div className="d-flex align-items-center">
        <FontAwesomeIcon
          icon={faTimes}
          role="button"
          aria-label="Close"
          onClick={closeOverlay}
          style={{
            cursor: "pointer",
            fontSize: "0.9rem",
          }}
        />
      </div>
    </div>
  );
};

export default OverlayHeader;
